<template>
  <v-menu
    v-model="showMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px">
    <template #activator="{on}">
      <base-text-field
        :value="formatDate(value, dateFormat)"
        clearable readonly
        prepend-inner-icon="mdi-calendar"
        v-bind="showIcon && {'append-icon':'mdi-database-arrow-left-outline'}"
        @click:clear="setDateVal(null, field.name)" v-on="on">
        <template #label>
          <span :class="{'red--text' : field.mandatory}">
            {{ field.mandatory ? `* ${field.alias}` : field.alias }}
          </span>
        </template>
      </base-text-field>
    </template>
    <v-date-picker
      :value="formatDate(value, 'YYYY-MM-DD')" :locale="locale" :first-day-of-week="firstDayOfTheWeek"
      @input="setDateVal($event, field.name)" />
  </v-menu>
</template>
<script>
import moment from 'moment'

export default {
  name: 'BaseDatePicker',
  props: {
    value: { type: Number, default () { return null } },
    field: { type: Object, default () { return null }, required: true },
    showIcon: { type: Boolean, default () { return false } },
  },
  data () {
    return {
      showMenu: false,
    }
  },
  computed: {
    language () {
      return this.$store.getters.getLanguage
    },
    locale () {
      switch (this.language) {
        case 'en':
          return 'en-US'
        case 'sr':
          return 'sr-RS'
        case 'cir':
          return 'sr-Latn-RS'
        case 'ba':
          return 'sr-Latn-RS'
        default:
          return 'en-US'
      }
    },
    firstDayOfTheWeek () {
      return 1
    },
    dateFormat () {
      if (this.$store.getters.getConfigJson.appConfig.dateFormat) {
        return this.$store.getters.getConfigJson.appConfig.dateFormat
      }
      return 'MM/DD/yyyy'
    },
  },
  methods: {
    formatDate (date, format) {
      return date ? moment(String(new Date(date))).format(format) : null
    },
    setDateVal (date) {
      this.showMenu = false
      this.$emit('input', date ? moment(date).valueOf() : null)
    },
  },
}
</script>
